module.exports = __webpack_public_path__ + "static/media/hasalon_thumb_even.506b6537.jpg";